import { IBetLegendItem } from './bet-tooltip.types';

export const BET_LEGEND_ITEMS: IBetLegendItem[] = [
  { label: 'K', value: '1000', match: 'K' },
  { label: 'M', value: '1000', match: 'M' },
  {
    label: (
      <>
        0.0<span className="text-md">3</span>1
      </>
    ),
    value: '0.0001',
    match: '0.0001',
  },
];
